import ModalUserAgreement from './ModalUserAgreementContainer';

export { ModalUserAgreement };


// WEBPACK FOOTER //
// ./src/modules/modal/ModalUserAgreement/index.js